module.exports = __webpack_public_path__ + "img/PXL_20230525_120642637.d8d144bd.jpg";